export default "__VITE_ASSET__cf3fe3f5__"